import React, { useState, useEffect } from 'react';

const CountdownTimer = ({ deadline }) => {
  const calculateTimeLeft = React.useCallback(() => {
    const difference = +new Date(deadline) - +new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    } else {
        timeLeft = { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }

    return timeLeft;
  }, [deadline]);

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearTimeout(timer);
  }, [calculateTimeLeft]);

  if(!isClient) return null;

  return (
    <div className="flex justify-center gap-4 mb-10">
      {Object.keys(timeLeft).map((interval) => (
        <div key={interval} className="flex flex-col items-center">
          <div className="w-16 h-16 sm:w-20 sm:h-20 bg-white/5 backdrop-blur-sm rounded-xl shadow-none border border-[#D4AF37]/20 flex items-center justify-center text-2xl sm:text-3xl font-extrabold text-[#D4AF37]">
            {String(timeLeft[interval]).padStart(2, '0')}
          </div>
          <span className="text-xs sm:text-sm font-bold text-gray-400 mt-2 uppercase tracking-wider">
            {interval}
          </span>
        </div>
      ))}
    </div>
  );
};

export default CountdownTimer;
